// src/cmps/TextEditor/nodes/ImageNode.jsx
import { DecoratorNode } from 'lexical'
import * as React from 'react'

function ImageComponent({ src, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      data-lexical-image
      className="block max-w-[70%] w-auto max-h-[500px] my-4"
      loading="lazy"
      draggable={false}
    />
  )
}

function convertImageElement(domNode) {
  const src = domNode.getAttribute('src') || ''
  const alt = domNode.getAttribute('alt') || ''
  return { node: new ImageNode(src, alt) }
}

export class ImageNode extends DecoratorNode {
  __src
  __alt

  static getType() {
    return 'image'
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__alt, node.__key)
  }

  constructor(src, alt = '', key) {
    super(key)
    this.__src = src
    this.__alt = alt
  }

  createDOM() {
    return document.createElement('span')
  }

  updateDOM() {
    return false
  }

  decorate() {
    return <ImageComponent src={this.__src} alt={this.__alt} />
  }

  static importJSON(serializedNode) {
    const { src, alt } = serializedNode
    return new ImageNode(src, alt)
  }

  exportJSON() {
    return {
      type: 'image',
      version: 1,
      src: this.__src,
      alt: this.__alt,
    }
  }

  // הוספת importDOM לזיהוי <img data-lexical-image>
  static importDOM() {
    return {
      img: (domNode) => {
        if (domNode.getAttribute('data-lexical-image') != null) {
          return {
            conversion: convertImageElement,
            priority: 1,
          }
        }
        return null
      },
    }
  }

  exportDOM() {
    const element = document.createElement('img')
    element.setAttribute('src', this.__src)
    if (this.__alt) element.setAttribute('alt', this.__alt)
    element.setAttribute('data-lexical-image', 'true')
    return { element }
  }

  getTextContent() {
    return '🖼️'
  }
}
